import React from 'react';

const EventDetailsModal = ({ event, onClose, formatTimestamp, getLevelColor }) => {
  if (!event) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
      <div className="relative top-20 mx-auto p-5 border w-11/12 md:w-3/4 lg:w-1/2 shadow-lg rounded-md bg-white">
        <div className="mt-3">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-semibold text-gray-900">Event Details</h3>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600"
            >
              <i className="fa-solid fa-times text-xl"></i>
            </button>
          </div>
          
          <div className="space-y-4">
            <div>
              <h4 className="font-medium text-gray-700">Message</h4>
              <p className="text-sm text-gray-900 mt-1">{event.message}</p>
            </div>
            
            <div className="grid grid-cols-2 gap-4">
              <div>
                <h4 className="font-medium text-gray-700">Level</h4>
                <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${getLevelColor(event.level)}`}>
                  {event.level}
                </span>
              </div>
              <div>
                <h4 className="font-medium text-gray-700">Timestamp</h4>
                <p className="text-sm text-gray-900 mt-1">{formatTimestamp(event.timestamp)}</p>
              </div>
            </div>
            
            <div>
              <h4 className="font-medium text-gray-700">User</h4>
              <p className="text-sm text-gray-900 mt-1">{event.user?.email || 'Unknown'}</p>
            </div>
            
            <div>
              <h4 className="font-medium text-gray-700">URL</h4>
              <p className="text-sm text-gray-900 mt-1">{event.context?.url || 'Unknown'}</p>
            </div>
            
            <div>
              <h4 className="font-medium text-gray-700">Environment</h4>
              <p className="text-sm text-gray-900 mt-1">{event.tags?.environment || 'Unknown'}</p>
            </div>
            
            <div>
              <h4 className="font-medium text-gray-700">Browser</h4>
              <p className="text-sm text-gray-900 mt-1">{event.tags?.browser || 'Unknown'}</p>
            </div>
            
            <div>
              <h4 className="font-medium text-gray-700">Operating System</h4>
              <p className="text-sm text-gray-900 mt-1">{event.tags?.os || 'Unknown'}</p>
            </div>
          </div>
          
          <div className="flex justify-end mt-6">
            <button
              onClick={onClose}
              className="bg-gray-500 hover:bg-gray-600 text-white font-bold py-2 px-4 rounded"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventDetailsModal; 